import { ChainId } from '@ui/types/chain';
import { ERC20Token, Token } from '@ui/types/token';

import { getErc20TokenList } from './tokens';
import { erc20Tokens, ERC20TokenSymbol } from './tokenSymbols';

const tokenMemoryCache: Partial<Record<ChainId, readonly ERC20Token[]>> = {};

export const getErc20Tokens = (chainId: ChainId): readonly ERC20Token[] => {
  const tokenList = tokenMemoryCache[chainId];
  if (tokenList) {
    return tokenList;
  }
  const newTokenList = Object.freeze(getErc20TokenList(chainId));
  tokenMemoryCache[chainId] = newTokenList;

  return newTokenList;
};

export const getErc20TokenByAddress = (
  address: string,
  chainId: ChainId,
): Token | undefined => {
  return getErc20Tokens(chainId).find(
    (v) => v.address?.toLowerCase() === address.toLowerCase(),
  );
};

export const getErc20TokenBySymbol = (
  symbol: ERC20TokenSymbol,
  chainId: ChainId,
): ERC20Token | undefined => {
  return getErc20Tokens(chainId).find((v) => v.symbol === symbol);
};

export const getIsErc20Token = (token: {
  symbol: string;
}): token is ERC20Token => {
  return erc20Tokens.includes(token.symbol as any);
};
